import { useTeacherProfile } from '@/contexts/TeacherProfileContext';
import { useTeacherOfferingsQuery } from '@/hooks/useNextSteps';
import { shouldShowOfferingBanner } from '@/lib/offeringNudge';

/** Whether to show the "add an offering" banner on the teacher dashboard. */
export function useOfferingNudgeBanner(): { show: boolean } {
  const { draftStatus, hasActiveVersion, isLoading: profileLoading } = useTeacherProfile();
  const { status, data } = useTeacherOfferingsQuery();

  return {
    show: shouldShowOfferingBanner({
      profileLoading,
      draftStatus,
      hasActiveVersion,
      offeringsStatus: status,
      offeringsData: data,
    }),
  };
}
